import { Injectable } from '@angular/core';
import { MailFolderType } from '@app-types/enums/mail-folder.type';
import { EmailColumnsEnum } from '@app-types/enums/emailColumns';
import { MAILS_COLUMNS } from '@app-shared/constants/constants';

@Injectable({ providedIn: 'root' })
export class EmailsColumnsService {
  constructor() {}

  public isColumnShow(
    mailFolderType: MailFolderType,
    isTo: boolean,
    isClass = false
  ): boolean {
    if (
      (mailFolderType && mailFolderType === MailFolderType.Inbox) ||
      mailFolderType === MailFolderType.Spam
    ) {
      return isTo;
    }
    if (
      mailFolderType &&
      mailFolderType >= MailFolderType.Inbox &&
      mailFolderType <= MailFolderType.Validation
    ) {
      return !isTo;
    } else {
      return isClass;
    }
  }

  getColumns(
    mailFolderType: MailFolderType,
    selectedMailFolderId: number | null,
    isMailFolderTypeOutbox: boolean,
    isShowFolderColumn: boolean
  ): string[] {
    const config: {
      [key: string]: boolean;
    } = {
      [EmailColumnsEnum.ArchiveStatus]:
        mailFolderType !== MailFolderType.Draft &&
        mailFolderType !== MailFolderType.Validation &&
        !isMailFolderTypeOutbox,
      [EmailColumnsEnum.Reply]: false,
      [EmailColumnsEnum.Attachment]: false,
      [EmailColumnsEnum.To]: !(selectedMailFolderId
        ? this.isColumnShow(mailFolderType, true)
        : true),
      [EmailColumnsEnum.From]: !(selectedMailFolderId
        ? this.isColumnShow(mailFolderType, false)
        : false),
      [EmailColumnsEnum.Source]: !(
        !selectedMailFolderId ||
        (mailFolderType !== MailFolderType.Archive &&
          mailFolderType !== MailFolderType.Trash)
      ),
      [EmailColumnsEnum.Meta]: !(
        !selectedMailFolderId || !isMailFolderTypeOutbox
      ),
      [EmailColumnsEnum.Folder]: isShowFolderColumn,
      [EmailColumnsEnum.State]: !(
        !selectedMailFolderId ||
        (mailFolderType !== MailFolderType.Sent &&
          mailFolderType !== MailFolderType.Archive &&
          mailFolderType !== MailFolderType.Outbox &&
          mailFolderType !== MailFolderType.Trash &&
          mailFolderType !== MailFolderType.View)
      ),
    };

    return [...MAILS_COLUMNS].filter(el => {
      return config?.[el as string] ?? true;
    });
  }
}
